export const ORDER_CATEGORY = {
    ALL: "all",
    CHALLAN: "challan",
    SERVICE_HISTORY: "service_history",
    CAR_WASH: "carwash",
    CAR_HEALTH_REPORT: "car_health_report",
    PRE_DELIVERY_INSPECTION: "pre_delivery_inspection",
    NEW_CAR_PRE_DELIVERY_INSPECTION: "new_car_pre_delivery_inspection",
    GS_SERVICE_HISTORY: "gs_service_history",
    C24_SERVICE_HISTORY: "C24_SERVICE_HISTORY",
    SELLER_PACKAGE: "seller_package",
    STUDIO_PHOTOS: "car_photoshoot_images",
    PRE_DELIVERY_INSPECTION_PACKAGE: "pre_delivery_inspection_package",
    C2B_SPOTLIGHT: "spotlight",
    SELLER_PACKAGE_V2: "seller_package_v2",
    SERVICE_HISTORY_PACKAGE: "service_history_package",
    DELIVERY: "delivery",
    USED_CAR_INSPECTION: "used_car_inspection",
    NEW_CAR_INSPECTION: "new_car_inspection"
};
